<template>
  <div>
    <div>
      <gameCmp 
        class="mainGameContainer"
        :gameData="gameData"
      ></gameCmp>
    </div>

    <img src="../../assets/images/games/rocket_game.png" alt="Preloaded Image" class="preloadImage">
  </div>
</template>

<script>
import allGamesData from '../../assets/json/games.json'
export default {
  name: 'puzzleGame',
  data() {
    return {
      gameData: allGamesData['puzzle']
    }
  }
}
</script>

<style scoped>
  .gameComplete.mainGameContainer:before {
    opacity: 1;
    top: 0;
    left: 0;
    right: -3px;
    bottom: -4px;
    background-image: url('../../assets/images/games/rocket_game.png');
  }
</style>